import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Descriptions,
  Tag,
  Button,
  Table,
  Space,
  Spin,
  Alert,
  Divider,
  Statistic,
} from "antd";
import {
  HomeOutlined,
  ShoppingCartOutlined,
  PrinterOutlined,
  EditOutlined,
  ArrowLeftOutlined,
  DollarOutlined,
  CalendarOutlined,
  PaperClipOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
  FileTextOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { useParams, Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import config from "../../../config";
import { FaDollarSign } from "react-icons/fa";
import { useFarmProfile } from "../../../contexts/FarmProfileContext";
import InvoiceView from "./SaleInvoicePage";

let avatarImage;
let profiles;

const SaleDetailPage = () => {
  const { id } = useParams();
  const { profile } = useFarmProfile();
  profiles = profile;

  return (
    <div>
      <InvoiceView saleId={id} />
    </div>
  );

  // return (
  //   <>
  //     <Row
  //       justify="space-between"
  //       align="middle"
  //       style={{ marginBottom: "24px" }}
  //     >
  //       <Col>
  //         <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
  //           <div>
  //             <h1 style={{ margin: 0, fontSize: "24px" }}>
  //               Sale Details - #{sale.id}
  //             </h1>
  //             <p style={{ margin: 0, color: "#666" }}>
  //               Transaction: {sale.transactionId}
  //             </p>
  //           </div>
  //         </div>
  //       </Col>
  //       <Col>
  //         <Space>
  //           <Link to="/transactions/all-sales">
  //             <Button
  //               icon={<ArrowLeftOutlined />}
  //               //   onClick={handleGoBack}
  //               size="small"
  //             >
  //               Back to Sales
  //             </Button>
  //           </Link>
  //           {/* <Link to={`/transactions/sales/edit/${sale.id}`}>
  //             <Button
  //               icon={<EditOutlined />}
  //               size="small"
  //             >
  //               Edit Sale
  //             </Button>
  //           </Link> */}

  //           {sale.paidAmount < sale.totalCost && (
  //             <Tag color="red">Payment Incomplete</Tag>
  //           )}
  //           {sale.paidAmount >= sale.totalCost && (
  //             <Button
  //               type="primary"
  //               icon={<PrinterOutlined />}
  //               loading={printing}
  //               onClick={handlePrintReceipt}
  //               size="small"
  //             >
  //               Print Receipt
  //             </Button>
  //           )}
  //         </Space>
  //       </Col>
  //     </Row>

  //     <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
  //       <Col xs={24} sm={6}>
  //         <Card>
  //           <Statistic
  //             title="Total Amount"
  //             value={sale.totalCost}
  //             prefix={<DollarOutlined />}
  //             valueStyle={{ color: "#860000ff" }}
  //             suffix="KES"
  //           />
  //         </Card>
  //       </Col>
  //       <Col xs={24} sm={6}>
  //         <Card>
  //           <Statistic
  //             title="Paid Amount"
  //             value={sale.paidAmount || 0}
  //             prefix={<FaDollarSign />}
  //             valueStyle={{ color: "#3f8600" }}
  //             suffix="KES"
  //           />
  //         </Card>
  //       </Col>
  //       <Col xs={24} sm={6}>
  //         <Card>
  //           <Statistic
  //             title="Items Count"
  //             prefix={<ShoppingCartOutlined />}
  //             value={sale.items?.length || 0}
  //             valueStyle={{ color: "#1890ff" }}
  //           />
  //         </Card>
  //       </Col>
  //       <Col xs={24} sm={6}>
  //         <Card>
  //           <Statistic
  //             title="Sale Date"
  //             prefix={<CalendarOutlined />}
  //             value={moment(sale.recorded).format("DD/MM/YYYY")}
  //             valueStyle={{ color: "#722ed1" }}
  //           />
  //         </Card>
  //       </Col>
  //     </Row>

  //     <Row gutter={[16, 16]}>
  //       {/* Sale Details */}
  //       <Col xs={24} lg={10}>
  //         <Card title="Sale Information" style={{ height: "100%" }}>
  //           <Descriptions bordered column={1} size="small">
  //             <Descriptions.Item label="Sale ID">
  //               <strong>{sale.id}</strong>
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Transaction ID">
  //               <Tag color="blue">{sale.transactionId}</Tag>
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Sale Date">
  //               {moment(sale.recorded).format("DD/MM/YYYY HH:mm")}
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Customer ID">
  //               {sale.stakeholderId ? (
  //                 <Tag color="green">Customer #{sale.stakeholderId}</Tag>
  //               ) : (
  //                 "N/A"
  //               )}
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Payment Method">
  //               <Tag color={getPaymentMethodColor(sale.paymentMethod)}>
  //                 {sale.paymentMethod?.toUpperCase()}
  //               </Tag>
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Payment Status">
  //               <Tag color={getStatusColor(sale.paymentStatus)}>
  //                 {sale.paymentStatus?.toUpperCase()}
  //               </Tag>
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Delivery Method">
  //               <Tag color="orange">
  //                 {sale.delivery?.toUpperCase() || "N/A"}
  //               </Tag>
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Delivery Person">
  //               {sale.delGuy ? `Person #${sale.delGuy}` : "N/A"}
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Recorded By">
  //               {sale.userName} (ID: {sale.userId})
  //             </Descriptions.Item>
  //             <Descriptions.Item label="Recorded Date">
  //               {moment(sale.createdAt).format("DD/MM/YYYY HH:mm")}
  //             </Descriptions.Item>
  //             {sale.notes && (
  //               <Descriptions.Item label="Notes">
  //                 {sale.notes}
  //               </Descriptions.Item>
  //             )}
  //           </Descriptions>
  //         </Card>
  //       </Col>

  //       {/* Sale Items */}
  //       <Col xs={24} lg={14}>
  //         <Card
  //           title={`Sale Items (${sale.items?.length || 0})`}
  //           style={{ height: "100%" }}
  //         >
  //           <Table
  //             dataSource={sale.items || []}
  //             columns={itemColumns}
  //             pagination={false}
  //             size="small"
  //             scroll={{ x: 800 }}
  //             rowKey="id"
  //             summary={() => (
  //               <Table.Summary>
  //                 <Table.Summary.Row>
  //                   <Table.Summary.Cell index={0} colSpan={4}>
  //                     <strong>Total Amount</strong>
  //                   </Table.Summary.Cell>
  //                   <Table.Summary.Cell index={1}>
  //                     <strong>KES {sale.totalCost?.toLocaleString()}</strong>
  //                   </Table.Summary.Cell>
  //                 </Table.Summary.Row>
  //               </Table.Summary>
  //             )}
  //           />
  //         </Card>
  //       </Col>
  //     </Row>

  //     <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
  //       <Col xs={24}>
  //         <Card title="Additional Information">
  //           <Row gutter={[16, 16]}>
  //             <Col xs={24} sm={8}>
  //               <strong>GL Debit:</strong> {sale.gl_debit || "1000"}
  //             </Col>
  //             <Col xs={24} sm={8}>
  //               <strong>GL Credit:</strong> {sale.gl_credit || "4000"}
  //             </Col>
  //             <Col xs={24} sm={8}>
  //               <strong>Archive Status:</strong>
  //               <Tag
  //                 color={sale.archive ? "red" : "green"}
  //                 style={{ marginLeft: "8px" }}
  //               >
  //                 {sale.archive ? "Archived" : "Active"}
  //               </Tag>
  //             </Col>
  //             {sale.dueDate && (
  //               <Col xs={24} sm={8}>
  //                 <strong>Due Date:</strong>{" "}
  //                 {moment(sale.dueDate).format("DD/MM/YYYY")}
  //               </Col>
  //             )}
  //             {sale.confirmDate && (
  //               <Col xs={24} sm={8}>
  //                 <strong>Confirm Date:</strong>{" "}
  //                 {moment(sale.confirmDate).format("DD/MM/YYYY")}
  //               </Col>
  //             )}
  //             <Col xs={24} sm={8}>
  //               <strong>Invoiced:</strong>
  //               <Tag
  //                 color={sale.invoiced ? "blue" : "default"}
  //                 style={{ marginLeft: "8px" }}
  //               >
  //                 {sale.invoiced ? "Yes" : "No"}
  //               </Tag>
  //             </Col>
  //           </Row>
  //         </Card>
  //       </Col>
  //     </Row>

  //     <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
  //       <Col xs={24}>
  //         <Card title="Attached Files">
  //           <Row gutter={[16, 16]}>
  //             {sale.image &&
  //               sale.image.split(",").map((rawFile, index) => {
  //                 const clean = cleanFileName(rawFile);
  //                 return (
  //                   <Col key={index}>
  //                     <Button
  //                       type="default"
  //                       icon={getFileIcon(clean)}
  //                       onClick={() => handleViewFile(clean)}
  //                       style={{
  //                         display: "flex",
  //                         alignItems: "center",
  //                         gap: 8,
  //                       }}
  //                     >
  //                       {clean}
  //                     </Button>
  //                   </Col>
  //                 );
  //               })}

  //             {!sale.image && <Col>No files attached</Col>}
  //           </Row>
  //         </Card>
  //       </Col>
  //     </Row>

  //     <Divider />
  //     <Row justify="center" style={{ marginTop: "24px" }}>
  //       <Space>
  //         <Link to="/transactions/all-sales">
  //           <Button
  //             icon={<ArrowLeftOutlined />}
  //             //   onClick={handleGoBack}
  //             size="small"
  //           >
  //             Back to Sales
  //           </Button>
  //         </Link>
  //         {/* <Link to={`/transactions/sales/edit/${sale.id}`}>
  //           <Button
  //             icon={<EditOutlined />}
  //             size="small"
  //           >
  //             Edit Sale
  //           </Button>
  //         </Link> */}
  //         {sale.paidAmount >= sale.totalCost && (
  //           <Button
  //             type="primary"
  //             icon={<PrinterOutlined />}
  //             loading={printing}
  //             onClick={handlePrintReceipt}
  //             size="small"
  //           >
  //             Print Receipt
  //           </Button>
  //         )}
  //       </Space>
  //     </Row>
  //   </>
  // );
};

// Helper functions
const getPaymentMethodColor = (method) => {
  const colors = {
    cash: "green",
    mpesa: "blue",
    bank: "purple",
    credit: "orange",
  };
  return colors[method] || "default";
};

const getStatusColor = (status) => {
  const colors = {
    cash: "green",
    unpaid: "red",
    partially_paid: "orange",
    fully_paid: "green",
  };
  return colors[status] || "default";
};

const getItemDescription = (item) => {
  if (item.productName) return item.productName;
  switch (item.itemType) {
    case "animal":
      return (
        ` ${item.category || ""} - ${item.identifier || ""} - qty (${
          item.quantity || 1
        })`
          .trim()
          .toUpperCase() || "ANIMAL"
      );
    case "poultry":
      return item.identifier ? `${item.identifier} BIRDS` : "POULTRY";
    case "egg":
      return `${(item.identifier || "NORMAL").toUpperCase()} EGGS`;
    case "dairy":
      return `${(item.identifier || "MILK").toUpperCase()} DAIRY`;
    case "trays":
      return `${(item.identifier || "PLASTIC").toUpperCase()} EGG TRAYS`;
    case "general":
      return `${(item.identifier || "Unknown").toString().toUpperCase()} ${
        item.unit || ""
      }`;
    default:
      return "GENERAL ITEM";
  }
};

const getItemQuantityDisplay = (item) => {
//   if (item.quantity) return item.quantity.toString();
  switch (item.itemType) {
    case "animal":
      return item.weightKg ? `${item.weightKg}kg` : "1";
    case "egg":
      return `${item.traysCount || 0} trays`;
    case "dairy":
      return `${item.liters || 0}L`;
    case "trays":
      return `${item.traysCount || 0}pcs`;
    case "general":
      return `${item.quantity || 0} ${item.unit || ""}`;
    default:
      return "1";
  }
};

// PDF Receipt Generation
const generateSaleReceiptPDF = (sale) => {
  return new Promise((resolve, reject) => {
    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [80, 297],
      });

      doc.setFont("courier", "normal");
      let yPosition = 15;

      // Header Section
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(profiles?.name || "FARM SYSTEM", 40, yPosition, {
        align: "center",
      });
      yPosition += 5;
      doc.text(profiles?.address1, 40, yPosition, { align: "center" });
      yPosition += 5;
      doc.setFontSize(8);
      doc.text(profiles?.address2, 40, yPosition, { align: "center" });
      yPosition += 8;

      // Receipt Info
      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;

      doc.setFontSize(9);
      doc.text(`Receipt: RCP-${sale.id}`, 5, yPosition);
      yPosition += 4;
      doc.text(`TXN: ${sale.transactionId}`, 5, yPosition);
      yPosition += 4;
      doc.text(
        `Date: ${moment(sale.recorded).format("DD/MM/YYYY HH:mm")}`,
        5,
        yPosition,
      );
      yPosition += 4;
      doc.text(`Staff: ${sale.userName}`, 5, yPosition);
      yPosition += 6;

      // Divider line
      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;

      // Customer Information
      if (sale.stakeholderId) {
        doc.text(`Customer ID: ${sale.stakeholderId}`, 5, yPosition);
        yPosition += 4;
      }
      doc.text(
        `Delivery: ${
          sale.deliveredMethod === "delivered" ? "DELIVERED" : "PICKED UP"
        }`,
        5,
        yPosition,
      );
      yPosition += 4;
      doc.text(
        `Payment: ${sale.paymentMethod?.toUpperCase() || "CASH"}`,
        5,
        yPosition,
      );
      yPosition += 6;

      // Divider line
      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;

      doc.setFontSize(8);
      doc.setFont(undefined, "bold");
      doc.text("ITEM", 5, yPosition);
      doc.text("QTY", 45, yPosition);
      doc.text("AMOUNT", 60, yPosition);
      yPosition += 4;

      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;

      doc.setFontSize(8);
      doc.setFont(undefined, "normal");
      sale.items?.forEach((item) => {
        const itemName = getItemDescription(item);
        const quantity = getItemQuantityDisplay(item);
        const subtotal = item.totalPrice;

        const lines = doc.splitTextToSize(itemName, 35);
        lines.forEach((line) => {
          if (yPosition > 270) {
            doc.addPage([80, 297]);
            yPosition = 10;
          }
          doc.text(line, 5, yPosition);
          yPosition += 4;
        });

        if (yPosition > 270) {
          doc.addPage([80, 297]);
          yPosition = 10;
        }
        doc.text(quantity, 45, yPosition - lines.length * 4 + 4);
        doc.text(
          `${subtotal?.toLocaleString()}`,
          60,
          yPosition - lines.length * 4 + 4,
        );
        yPosition += 2;
      });

      // Total
      if (yPosition > 270) {
        doc.addPage([80, 297]);
        yPosition = 10;
      }
      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;

      // Add tax if applicables
      const tax = 0; // Adjust based on your tax calculation
      if (tax > 0) {
        doc.text("VAT (16%):", 5, yPosition);
        doc.text(`KES ${tax.toLocaleString()}`, 60, yPosition);
        yPosition += 5;
      }
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.text("TOTAL:", 5, yPosition);
      doc.text(`${sale.totalCost?.toLocaleString()}`, 60, yPosition);
      yPosition += 8;

      // Divider line
      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;

      // Payment Details
      doc.setFontSize(9);
      doc.setFont(undefined, "normal");
      doc.text(
        `Paid: ${sale.paymentMethod?.toUpperCase() || "CASH"}`,
        5,
        yPosition,
      );
      yPosition += 4;
      doc.text(
        `Amount Paid: KES ${sale.totalCost?.toLocaleString()}`,
        5,
        yPosition,
      );
      yPosition += 4;
      doc.text(`Change: KES 0`, 5, yPosition); // Adjust if you handle change
      yPosition += 8;

      // Divider line
      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;

      // Footer
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text("THANK YOU!", 40, yPosition, { align: "center" });
      yPosition += 4;
      doc.text("For inquiries:", 40, yPosition, { align: "center" });
      yPosition += 4;
      doc.text(profiles?.phone1 || "", 40, yPosition, { align: "center" });
      yPosition += 4;
      doc.text(profiles?.email || "", 40, yPosition, { align: "center" });
      yPosition += 6;

      // Final divider and timestamp
      doc.line(5, yPosition, 75, yPosition);
      yPosition += 5;
      doc.text(moment().format("DD/MM/YYYY HH:mm:ss"), 40, yPosition, {
        align: "center",
      });

      // Paper cut indicator (for thermal printers that support auto-cutting)
      yPosition += 10;
      doc.setFontSize(6);
      doc.text("***", 40, yPosition, { align: "center" });

      // Open in new window for printing
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const printWindow = window.open(pdfUrl, "_blank");

      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
          resolve();
        };
      } else {
        reject(new Error("Popup blocked. Please allow popups for this site."));
      }
    } catch (error) {
      reject(error);
    }
  });
};

export default SaleDetailPage;
